SP.NotificationBar = Garnish.Base.extend({
    $el: null,
    $closeBtn: null,

    init(el) {
        this.$el = $(el)
        this.$closeBtn = this.$el.find('.close')

        this.checkNotificationStatus()

        this.addListener(this.$closeBtn, 'click', 'hide')
    },

    hide(ev) {
        ev.preventDefault()
        window.localStorage.setItem('SP-Notifications-Global-Hidden', '1')
        $('body').removeClass('has-notification')

        this.$el.velocity('slideUp', {duration: Garnish.FX_DURATION}, function () {
            this.$el.detach()
        }.bind(this))
    },

    checkNotificationStatus() {
        let key = window.localStorage.getItem('SP-Notifications-Global-Hidden')

        if (!key) {
            this.$el.velocity('slideDown', {duration: Garnish.FX_DURATION}, function () {
                $('body').addClass('has-notification')
            }.bind(this))
        } else {
            $('body').removeClass('has-notification')
        }
    }
})